import get from 'lodash/get';

class DefaultDialogController {
  constructor() {
    const resolve = get(this, '$resolve') || {};
    Object.keys(resolve).forEach((key) => {
      this[key] = resolve[key];
    });
  }

  close() {
    return this.$dismiss();
  }

  confirm(result) {
    return this.$close(result);
  }
}

export default DefaultDialogController;



// WEBPACK FOOTER //
// ./src/modules/utils/notifications/default-dialog-controller.js